let api = {};
// 获取token
api.login = '/login';

// 系统通知
api.alert = {
    //列表查询
    list: '/PILEHOME/api/alert/list',
    findonebyid: '/PILEHOME/api/alert/findonebyid',
    edit: '/PILEHOME/api/alert/edit',
    add: '/PILEHOME/api/alert/add',
    delete: '/PILEHOME/api/alert/delete',
    listall: '/PILEHOME/api/alert/listall',
    export: '/PILEHOME/api/alert/export'
};
//充电桩管理
api.pileManage = {
    list: '/PILEHOME/api/pile/list',
    edit: '/PILEHOME/api/pileManage/edit',
    add: '/PILEHOME/api/pileManage/add',
    delete: '/PILEHOME/api/pileManage/delete',
    findonebyid: '/PILEHOME/api/pileManage/findonebyid',
    listall: '/PILEHOME/api/pileManage/listall',
    order: '/PILEHOME/api/pilecontrol',
    pilesurroundinquiry: '/PILEHOME/api/auto/pilesurroundinquiry',
    //充电控制
    control: '/PILEHOME/api/pile/',
    //修改充电桩的公司
    editcorp: '/PILEHOME/api/pile/edit/corp'

};
api.autoTeam = {
    list: "/PILEHOME/api/autoteam/list",
    edit: "/PILEHOME/api/autoteam/edit",
    add: "/PILEHOME/api/autoteam/add",
    delete: "/PILEHOME/api/autoteam/delete",
    findonebyid: "/PILEHOME/api/autoteam/findonebyid/",
    listall: "/PILEHOME/api/autoteam/listall",
    findonebycorpno: "/PILEHOME/api/autoteam/findonebycorpno/"
};
api.autoMatain = {
    list: '/PILEHOME/api/autoMatain/list',
    add: "/PILEHOME/api/autoMatain/add",
    edit: "/PILEHOME/api/autoMatain/edit",
    listall: "/PILEHOME/api/autoMatain/listall",
    findonebyid: "/PILEHOME/api/autoMatain/findonebyid/",
};
api.event = {
    list: "/PILEHOME/api/event/list",
    add: "/PILEHOME/api/event/add",
    edit: "/PILEHOME/api/event/edit",
    delete: "/PILEHOME/api/event/delete",
    export: "/PILEHOME/api/event/export",
    listall: "/PILEHOME/api/event/listall",
    findonebyid: '/PILEHOME/api/event/findonebyid/',
}
//经销商
api.dealer = {
    page: "/PILEHOME/api/dealer/page",
    add: "/PILEHOME/api/dealer/add",
    edit: "/PILEHOME/api/dealer/edit",
    delete: "/PILEHOME/api/dealer/delete/",
    findonebyid: "/PILEHOME/api/dealer/findonebyid/",
    discountNo: "/PILEHOME/api/discount/info/",
    discountList: "/PILEHOME/api/discount/list",
    //内部折扣
    inside: "/PILEHOME/api/dealer/bind/discount/",
    //结算策略下拉框
    Settlement: "/PILEHOME/api/strategy/list",
    //关联结算策略内部折扣
    strategy: "/PILEHOME/api/dealer/bind/strategy/",
    //结算详情
    strategyList: "/PILEHOME/api/strategy/info/",
    //结算记录
    record: "/PILEHOME/api/dealer/strategy/list",
    //导出
    export: "/PILEHOME/api/custwalletlist/export",
    //账单
    bill: "/PILEHOME/api/dealer/strategy/bill",
}
//RCS型号管理
api.rcstype = {
    //分页查询
    list: '/PILEHOME/api/rcs/type/list',
    //编辑
    edit: '/PILEHOME/api/rcs/type/edit',
    //增加
    add: '/PILEHOME/api/rcs/type/add',
    //删除
    delete: '/PILEHOME/api/rcs/type/delete',
    //获取所有
    listall: '/PILEHOME/api/rcs/type/listall',
    //根据ID查询
    findonebyid: '/PILEHOME/api/rcs/type/findonebyid',
};
//RCS设备管理
api.rcs = {
    //分页查询
    list: '/PILEHOME/api/rcs/list',
    //删除
    delete: '/PILEHOME/api/rcs/delete',
    //增加
    add: '/PILEHOME/api/rcs/add',
    //编辑
    edit: '/PILEHOME/api/rcs/edit',
    //导出
    export: '/PILEHOME/api/rcs/export',
    //根据ID查询
    findonebyid: '/PILEHOME/api/rcs/findonebyid',
    //获取所有
    listall: "/PILEHOME/api/rcs/listall"
}

//内部折扣管理
api.discount = {
    //不分页
    list: '/PILEHOME/api/discount/list',
    //分页
    page: '/PILEHOME/api/discount/page',
    findonebyid: '/PILEHOME/api/discount/findByDiscountId',
    add: '/PILEHOME/api/discount/add',
    delete: '/PILEHOME/api/discount/delete',
    edit: '/PILEHOME/api/discount/edit',
    disable: '/PILEHOME/api/discount/disable',
    enable: '/PILEHOME/api/discount/enable',
    config: '/PILEHOME/api/sysconfig/findbytype',
}

//资费管理
api.tariff = {
    //分页查询
    page: '/PILEHOME/api/pileCharge/page',
    findonebyid: '/PILEHOME/api/pileCharge/findonebyid',
    add: '/PILEHOME/api/pileCharge/add',
    delete: '/PILEHOME/api/pileCharge/delete',
    edit: '/PILEHOME/api/pileCharge/edit',
    disable: '/PILEHOME/api/pileCharge/logout',
    enable: '/PILEHOME/api/pileCharge/login',
    config: '/PILEHOME/api/sysconfig/findbytype'
}
//商品管理
api.goods = {
    page: '/PILEHOME/api/good/page',
    delete: '/PILEHOME/api/good/delete',
    findonebyid: '/PILEHOME/api/good/findbyid',
    add: '/PILEHOME/api/good/save',
    edit: '/PILEHOME/api/good/update',
    downgood: '/PILEHOME/api/good/lowerShelf',
    upgood: '/PILEHOME/api/good/upperShelf',
    config: '/PILEHOME/api/sysconfig/findbytype',

}
//广告页面
api.advert = {
    //分页查询
    list: '/PILEHOME/api/advert/list',
    page: '/PILEHOME/api/advert/page',
    add: '/PILEHOME/api/advert/add',
    edit: '/PILEHOME/api/advert/edit',
    enable: '/PILEHOME/api/advert/adenable',
    disable: '/PILEHOME/api/advert/addisable',
    findonebyid: '/PILEHOME/api/advert/findbyid',
    delete: '/PILEHOME/api/advert/delete',
}
// 广告计划管理
api.advertproject = {
    page: '/PILEHOME/api/advertproject/page',
    add: '/PILEHOME/api/advertproject/add',
    edit: '/PILEHOME/api/advertproject/edit',
    on: '/PILEHOME/api/advertproject/editon',
    off: '/PILEHOME/api/advertproject/editoff',
    findbyid: '/PILEHOME/api/advertproject/findbyid'
}

//充电桩型号管理
api.pileType = {
    //不分页
    list: '/PILEHOME/api/piletype/list',
    //分页
    page: '/PILEHOME/api/piletype/page',
    findonebyid: '/PILEHOME/api/piletype/info/',
    add: '/PILEHOME/api/piletype/add',
    delete: '/PILEHOME/api/piletype/delete/',
    edit: '/PILEHOME/api/piletype/edit',
    listall: '/PILEHOME/api/pile/type/listall',
    //注销充电桩
    disable: '/PILEHOME/api/piletype/disable/',
    //启用充电桩
    enable: '/PILEHOME/api/piletype/enable/'

}

//网点营业统计
api.rentalStatistics = {
    list: '/PILEHOME/api/rpt001/list',
    findCityByCorpNo: '/PILEHOME/api/rental/findCityByCorpNo',
}
//用户注册统计
api.userRegisterStatistics = {
    list: '/PILEHOME/api/rpt003/list',
}
//下单时间段统计
api.orderTimeInterval = {
    list: '/PILEHOME/api/rpt006/list',
}
//车辆报警
api.vehicleAlarm = {
    list: '/PILEHOME/api/tmnlwarn/list',
    export: '/PILEHOME/api/tmnlwarn/export',
}
//OTA通讯记录
api.pileotarecord = {
    list: '/PILEHOME/api/pile/otarecord/list',
    export: '/PILEHOME/api/pile/otarecord/export',
    findonebyid: '/PILEHOME/api/pile/otarecord/findonebyid',
}
api.pilestatushistory = {
    list: '/PILEHOME/api/pilestautshistory/page',

}
api.pileStation = {
    list: '/PILEHOME/api/pile/station/list',
    add: "/PILEHOME/api/pile/station/add",
    edit: '/PILEHOME/api/pile/station/edit',
    delete: '/PILEHOME/api/pile/station/delete',
    findonebyid: '/PILEHOME/api/pile/station/findonebyid/',
    listall: '/PILEHOME/api/pile/station/listall',
    //根据充电网点找出的充电记录
    record: '/PILEHOME/api/pilestation/strategy/list',
    //根据充电网点找出的账单
    bill: "/PILEHOME/api/pilestation/strategy/bill",
}
//OTA通讯协议解析
api.history = {
    list: '/PILEHOME/api/pile/history/list',
}

//客户短信查询
api.custsms = {
    list: '/PILEHOME/api/custsms/list',
}

//客户推送消息
api.custpushmsg = {
    list: '/PILEHOME/api/cust/msg/list',
    edit: '/PILEHOME/api/cust/msg/edit',
    delete: '/PILEHOME/api/cust/msg/delete/',
    detail: '/PILEHOME/api/cust/msg/detail',
}

//客户反馈
api.feedback = {
    list: '/PILEHOME/api/custfeedback/list',
    edit: '/PILEHOME/api/custfeedback/edit',
    findonebyid: '/PILEHOME/api/custfeedback/findonebyid',
}

//用户来源报表
api.rpt002 = {
    list: '/PILEHOME/api/rpt002/list',
}

//运维报表
api.rpt004 = {
    list: '/PILEHOME/api/rpt004/list',
}

//订单趋势分析报表
api.rpt005 = {
    list: '/PILEHOME/api/rpt005/list',
}

//运营商管理 公司
api.operator = {
    //分页
    page: '/PILEHOME/api/corp/page',
    //不分页
    list: '/PILEHOME/api/corp/list',
    //添加
    add: '/PILEHOME/api/corp/add',
    //编辑
    edit: '/PILEHOME/api/corp/edit',
    //根据id查找
    findonebyid: '/PILEHOME/api/corp/info',
    //删除
    delete: '/PILEHOME/api/corp/delete',
    //根据公司查找经销商
    findByCorpNo: '/PILEHOME/api/dealer/findByCorpNo',
    //根据公司查找角色
    findRoleByCorpNo: '/PILEHOME/api/role/list'
}
//运维人员管理
api.operation = {
    list: '/PILEHOME/api/operation/list',
    delete: '/PILEHOME/api/operation/delete',
    findonebyid: '/PILEHOME/api/operation/findonebyid',
    edit: '/PILEHOME/api/operation/edit',
    add: '/PILEHOME/api/operation/add',
    resetpwd: '/PILEHOME/api/operation/modifypwd',
    listall: '/PILEHOME/api/operation/listall',
    export: '/PILEHOME/api/operation/export',
    excel: '/PILEHOME/api/operation/excel',
};

//发票管理
api.custInvoice = {
    list: '/PILEHOME/api/inv/list',
    export: '/PILEHOME/api/inv/export',
    delete: '/PILEHOME/api/inv/delete',
    findonebyid: '/PILEHOME/api/inv/findbyid',
    edit: '/PILEHOME/api/inv/edit',
    listall: '/PILEHOME/api/inv/listall'
};

//消息群推管理
api.pushmessage = {
    list: '/PILEHOME/api/message/push/list',
    listcust: '/PILEHOME/api/message/push/listcust',
    add: '/PILEHOME/api/message/push/add'
}

//运维管理-兑换卡
api.cashcard = {
    list: '/PILEHOME/api/redeem/page',
    add: '/PILEHOME/api/redeem/addbatch',
    makeCard: '/PILEHOME/api/redeem/makebatch'
};

//运维订单管理
api.optorder = {
    list: '/PILEHOME/api/optorder/list',
    export: '/PILEHOME/api/optorder/export',
    close: '/PILEHOME/api/optorder/close',
};

//预约订单管理
api.book = {
    list: '/PILEHOME/api/book/list',
    listall: '/PILEHOME/api/book/listall',
    export: '/PILEHOME/api/book/export'
};

//操作日志管理
api.actionlog = {
    list: '/PILEHOME/api/action/list'
};

// 用户管理
api.user = {
    // 登录
    login: '/PILEHOME/api/user/login',
    // 列表
    list: '/PILEHOME/api/user/list',
    // 根据id 查询
    findonebyid: '/PILEHOME/api/user/findonebyid/',
    // 更新
    edit: '/PILEHOME/api/user/edit',
    delete: '/PILEHOME/api/user/delete',
    add: '/PILEHOME/api/user/add',
    // 用户菜单
    usermenu: '/PILEHOME/api/user/usermenu',
    findbyphone: '/PILEHOME/api/user/findbyphone',
    export: '/PILEHOME/api/user/export',
    resetpwd: '/PILEHOME/api/user/resetpwd',
};

// 角色管理
api.role = {
    // 列表
    list: '/PILEHOME/api/role/list',
    del: '/PILEHOME/api/role/delete',
    findonebyid: '/PILEHOME/api/role/findonebyid',
    add: '/PILEHOME/api/role/add',
    edit: '/PILEHOME/api/role/edit',
    // 根据角色获取菜单
    listmenu: '/PILEHOME/api/role/listmenu',
    // 获取所有的角色
    listall: '/PILEHOME/api/role/listall',
    export: '/PILEHOME/api/role/export'
};


// 公司管理
api.corp = {
    // 列表
    list: '/PILEHOME/api/corp/list',
    // 根据id 查询
    findonebyid: '/PILEHOME/api/corp/findonebyid',
    findbycorpno: '/PILEHOME/api/corp/findbycorpno',
    // 根据name查询
    findbyname: '/PILEHOME/api/corp/findbyname',
    // 更新
    update: '/PILEHOME/api/corp/edit',
    delete: '/PILEHOME/api/corp/delete',
    add: '/PILEHOME/api/corp/add',
    // 用户菜单
    usermenu: '/PILEHOME/api/user/usermenu',
    // 所有
    listall: '/PILEHOME/api/corp/list',
    export: '/PILEHOME/api/corp/export',
    findcorpbyphone: '/PILEHOME/api/user/findcorpbyphone',
};
//组织机构
api.org = {
    // 列表
    list: '/PILEHOME/api/organization/list',
    //添加
    add: '/PILEHOME/api/organization/add',
    //修改
    update: '/PILEHOME/api/organization/edit',
    //删除
    delete: '/PILEHOME/api/organization/delete',
    // 根据id查询
    findbyid: '/PILEHOME/api/organization/findbyid/',
    //不分页
    listall: '/PILEHOME/api/organization/listall',
    //下拉列表(父子级)
    findCompanyAndDepts: '/PILEHOME/api/organization/findCompanyAndDepts/',
};
// 客户管理
api.cust = {
    // 列表
    list: '/PILEHOME/api/cust/list',
    // 根据id查询
    findbyid: '/PILEHOME/api/cust/findbyid',
    // 更新
    update: '/PILEHOME/api/cust/edit',
    // 停用
    stop: '/PILEHOME/api/cust/stop',
    add: '/PILEHOME/api/cust/add',
    // 用户菜单
    usermenu: '/PILEHOME/api/user/usermenu',
    // 所有
    listall: '/PILEHOME/api/cust/listall',
    export: '/PILEHOME/api/cust/export',
    //发送消息
    sendmessage: '/PILEHOME/api/cust/sendmessage',
    //修改手机号
    resetmoblie: '/PILEHOME/api/cust/resetphone',
    //修改密码
    resetpwd: '/PILEHOME/api/cust/modify/password',
    excel: '/PILEHOME/api/cust/excel',
    //删除
    delete: '/PILEHOME/api/cust/delete',
};
// 客户钱包管理
api.custwallet = {
    //钱包充值
    change: '/PILEHOME/api/custwallet/change'
}
// 资费包管理
api.tariffgroup = {
    // 列表
    list: '/PILEHOME/api/tariffgroup/list',
    // 根据id查询
    findbygrup: '/PILEHOME/api/tariffgroup/findbygrup',
    // 更新
    update: '/PILEHOME/api/tariffgroup/edit',
    delete: '/PILEHOME/api/tariffgroup/delete',
    add: '/PILEHOME/api/tariffgroup/add',
    // 用户菜单
    usermenu: '/PILEHOME/api/user/usermenu',
    // 所有
    listall: '/PILEHOME/api/tariffgroup/listall',
    export: '/PILEHOME/api/tariffgroup/export'
};

// 费用管理
api.feeitem = {
    // 列表
    list: '/PILEHOME/api/feeitem/list',
    // 根据id查询
    findonebyid: '/PILEHOME/api/feeitem/findonebyid',
    // 更新
    update: '/PILEHOME/api/feeitem/edit',
    delete: '/PILEHOME/api/feeitem/delete',
    add: '/PILEHOME/api/feeitem/add',
    // 用户菜单
    usermenu: '/PILEHOME/api/user/usermenu',
    // 所有
    listall: '/PILEHOME/api/feeitem/listall',
    export: '/PILEHOME/api/feeitem/export',
    //listitemCode:'/PILEHOME/api/feeitem/listitemCode',
};

// 菜单管理
api.menu = {
    // 所有菜单
    listall: '/PILEHOME/api/menu/listall'
};
api.qrUrl = {
    url: '118.25.36.217:8890'
}
// 设备管理
api.terminal = {
    list: '/PILEHOME/api/terminal/list',
    delete: '/PILEHOME/api/terminal/delete',
    add: '/PILEHOME/api/terminal/add',
    findonebyid: '/PILEHOME/api/terminal/findbyterminalid',
    findonebyNo: '/PILEHOME/api/terminal/findbyterminalno',
    edit: '/PILEHOME/api/terminal/edit',
    export: '/PILEHOME/api/terminal/export',
    listall: '/PILEHOME/api/terminal/listall',
    excel: '/PILEHOME/api/terminal/excel',
    updateVersion: '/PILEHOME/api/terminal/updateversion'
};
// 站点管理
api.rental = {
    list: '/PILEHOME/api/rental/list',
    delete: '/PILEHOME/api/rental/delete',
    add: '/PILEHOME/api/rental/add',
    export: '/PILEHOME/api/rental/export',
    findonebyid: '/PILEHOME/api/rental/findonebyid',
    edit: '/PILEHOME/api/rental/edit',
    findlistbylocation: '/PILEHOME/api/rental/findlistbylocation',
    excel: '/PILEHOME/api/rental/excel',
    listall: '/PILEHOME/api/rental/listall',
};
// 围栏管理
api.fence = {
    list: '/PILEHOME/api/fence/list',
    delete: '/PILEHOME/api/fence/delete',
    add: '/PILEHOME/api/fence/add',
    export: '/PILEHOME/api/fence/export',
    findonebyid: '/PILEHOME/api/fence/findonebyid',
    findonebyno: '/PILEHOME/api/fence/findonebyno',
    edit: '/PILEHOME/api/fence/edit',
    listall: '/PILEHOME/api/fence/listall',
    enableordisenable: '/PILEHOME/api/fence/enableordisenable',
    bindautolist: '/PILEHOME/api/fenceAuto/bindautolist',
    findlistbyfenceno: '/PILEHOME/api/fencePhone/findlistbyfenceno',
    fencephoneadd: '/PILEHOME/api/fencePhone/add',
    fencephonedelete: '/PILEHOME/api/fencePhone/delete',
    autoadd: '/PILEHOME/api/fenceAuto/add',
    untieautolist: '/PILEHOME/api/fenceAuto/untieautolist',
    untieautodelete: '/PILEHOME/api/fenceAuto/delete',
    tmnlwarnlist: '/PILEHOME/api/tmnlwarn/list',
    tmnlwarnexport: '/PILEHOME/api/tmnlwarn/export'
};
// 景点管理
api.travelPlace = {
    list: '/PILEHOME/api/travelplace/list',
    delete: '/PILEHOME/api/travelplace/delete',
    add: '/PILEHOME/api/travelplace/add',
    findonebyid: '/PILEHOME/api/travelplace/findonebyid',
    edit: '/PILEHOME/api/travelplace/edit',
    listall: '/PILEHOME/api/travelplace/listall',
};

// 站点车辆相关
api.autorentalrelation = {
    add: '/PILEHOME/api/autorentalrelation/add',
    delete: '/PILEHOME/api/autorentalrelation/delete',
    edit: '/PILEHOME/api/autorentalrelation/edit',
    list: '/PILEHOME/api/autorentalrelation/list',
    findonebyrentalno: '/PILEHOME/api/autorentalrelation/findonebyrentalno',
    export: '/PILEHOME/api/autorentalrelation/export',
};

// 设备信息履历
api.tmnlinfo = {
    list: '/PILEHOME/api/tmnlinfo/list',
    export: '/PILEHOME/api/tmnlinfo/export',
}
// 车辆违章管理
api.lvvr = {
    list: '/PILEHOME/api/lvvr/list',
    sendmessage: '/PILEHOME/api/cust/sendmessage',
    export: '/PILEHOME/api/lvvr/export',
    exportDate: '/PILEHOME/api/lvvr/exportDate',
    excel: '/PILEHOME/api/lvvr/excel',
    handle: '/PILEHOME/api/lvvr/handle',
    listall: '/PILEHOME/api/lvvr/listall',
    findbyid: '/PILEHOME/api/lvvr/pic'
}
// 电池信息履历
api.tmnlbatteryinfo = {
    list: '/PILEHOME/api/tmnlbatteryinfo/list',
    export: '/PILEHOME/api/tmnlbatteryinfo/export',
}
//设备测试
api.tmnltest = {
    tmnltest: '/PILEHOME/api/tmnltest/tmnltest',
    list: '/PILEHOME/api/tmnltest/list',
}
// 发送命令日志
api.otacommand = {
    list: '/PILEHOME/api/otacommand/list',
    export: '/PILEHOME/api/otacommand/export'
}
// 实时信息日志
api.otarecord = {
    list: '/PILEHOME/api/otarecord/list',
    export: '/PILEHOME/api/otarecord/export'
}
// 登录日志
api.loginlog = {
    list: '/PILEHOME/api/loginlog/list',
    export: '/PILEHOME/api/loginlog/export'
}
// 车辆管理
api.auto = {
    list: '/PILEHOME/api/auto/list',
    delete: '/PILEHOME/api/auto/delete',
    add: '/PILEHOME/api/auto/add',
    findonebyid: '/PILEHOME/api/auto/findonebyid',
    edit: '/PILEHOME/api/auto/edit',
    listall: '/PILEHOME/api/auto/listall',
    export: '/PILEHOME/api/auto/export',
    excel: '/PILEHOME/api/auto/excel',
    findonebyautono: '/PILEHOME/api/auto/findonebyautono',
    listallnoauth: '/PILEHOME/api/auto/listallnoauth',
    findbylicensenoauth: '/PILEHOME/api/auto/findbylicensenoauth',
};
// 车辆月检
api.autoMonthCheck = {
    delete: '/PILEHOME/api/autoMonthCheck/delete',
    add: '/PILEHOME/api/autoMonthCheck/add',
    findonebyautoid: '/PILEHOME/api/autoMonthCheck/findonebyautoid',
};
// 车辆保险
api.autoinsurance = {
    list: '/PILEHOME/api/autoinsurance/list',
    delete: '/PILEHOME/api/autoinsurance/delete',
    add: '/PILEHOME/api/autoinsurance/add',
    findonebyautono: '/PILEHOME/api/autoinsurance/findbyautono',
    findbyid: '/PILEHOME/api/autoinsurance/findbyid',
    edit: '/PILEHOME/api/autoinsurance/edit',
    export: '/PILEHOME/api/autoinsurance/export',
    listall: '/PILEHOME/api/autoinsurance/listall',
    update: '/PILEHOME/api/autoinsurance/edit',
    excel: '/PILEHOME/api/autoinsurance/excel',
};
//车型管理 automodel
api.automodel = {
    list: '/PILEHOME/api/automodel/list',
    delete: '/PILEHOME/api/automodel/delete',
    add: '/PILEHOME/api/automodel/add',
    findonebyid: '/PILEHOME/api/automodel/findonebyid',
    edit: '/PILEHOME/api/automodel/edit',
    export: '/PILEHOME/api/automodel/export',
    listall: '/PILEHOME/api/automodel/listall',
    excel: '/PILEHOME/api/automodel/excel',
    findautomodelandnum: '/PILEHOME/api/automodel/findautomodelandnum'
};
// 车辆电池管理
api.autobattery = {
    // 列表
    list: '/PILEHOME/api/autobattery/list',
    // 根据id查询
    findbyid: '/PILEHOME/api/autobattery/findbyid',
    // 更新
    update: '/PILEHOME/api/autobattery/edit',
    delete: '/PILEHOME/api/autobattery/delete',
    add: '/PILEHOME/api/autobattery/add',
    // 用户菜单
    usermenu: '/PILEHOME/api/user/usermenu',
    // 所有
    listall: '/PILEHOME/api/autobattery/listall',
    export: '/PILEHOME/api/autobattery/export',
    excel: '/PILEHOME/api/autobattery/excel',
    findbytmnlcode: '/PILEHOME/api/autobattery/findbyTmnlCode/',
};

// 设备实时状态
api.tmnlreal = {
    list: '/PILEHOME/api/tmnlreal/list',
    delete: '/PILEHOME/api/tmnlreal/delete',
    add: '/PILEHOME/api/tmnlreal/add',
    findonebyid: '/PILEHOME/api/tmnlreal/findonebyid',
    edit: '/PILEHOME/api/tmnlreal/edit',
    export: '/PILEHOME/api/tmnlreal/export'
};

// 系统配置管理
api.sysconfig = {
    findbytype: '/PILEHOME/api/sysconfig/findbytype',
    list: '/PILEHOME/api/sysconfig/list',
    add: '/PILEHOME/api/sysconfig/add',
    edit: '/PILEHOME/api/sysconfig/edit',
    delete: '/PILEHOME/api/sysconfig/delete',
    batchadd: '/PILEHOME/api/sysconfig/batchadd'
};
// 城市区域
api.area = {
    listchild: '/PILEHOME/api/area/listchild'
};

// 礼包管理
api.gift = {
    list: '/PILEHOME/api/gift/list',
    findonebyid: '/PILEHOME/api/gift/detail',
    edit: '/PILEHOME/api/gift/edit',
    add: '/PILEHOME/api/gift/add',
    delete: '/PILEHOME/api/gift/delete',
    allot: '/PILEHOME/api/gift/allot',
    show: '/PILEHOME/api/gift/detail',
    remove: '/PILEHOME/api/gift/remove'
}

// 车辆控制
api.autocontrol = {
    cmd: '/PILEHOME/api/autocontrol'
};

// 仪表盘
api.dashboard = {
    list: '/PILEHOME/api/kpi/home',
    tmnldetail: '/PILEHOME/api/kpi/count',
    chart: '/PILEHOME/api/dashbord/chart',
    autoChart: '/PILEHOME/api/dashbord/autoChart',
    custChart: '/PILEHOME/api/dashbord/custChart',
    orderChart: '/PILEHOME/api/dashbord/orderChart',
    detailChart: '/PILEHOME/api/dashbord/detailChart',
};

//客户退费管理
api.custwalletearnestwithdraw = {
    list: '/PILEHOME/api/custwalletearnestwithdraw/list',
    verify: '/PILEHOME/api/custwalletearnestwithdraw/verify',
    reject: '/PILEHOME/api/custwalletearnestwithdraw/rejectcustwalletearnestwithdraw',
    export: '/PILEHOME/api/custwalletearnestwithdraw/export',
    findbyid: '/PILEHOME/api/custwalletearnestwithdraw/findbyid',
    agree: '/PILEHOME/api/custwalletearnestwithdraw/financialaudit',
    sentinfo: '/PILEHOME/api/custwalletearnestwithdraw/sentinfo',
    findall: '/PILEHOME/api/custwalletearnestwithdraw/findall',

};
//订单管理
api.order = {
    //订单详情
    detail: '/PILEHOME/api/order/detail',
    //订单确认
    confirm: '/PILEHOME/api/order/confirm',
    //订单列表分页
    page: '/PILEHOME/api/order/page',
    // 列表
    list: '/PILEHOME/api/rent/order/list',
    // 根据id 查询
    findbyid: '/PILEHOME/api/rent/order/findbyid',
    // 根据name查询
    findbyname: '/PILEHOME/api/rent/order/findbyname',
    // 更新
    update: '/PILEHOME/api/rent/order/edit',
    delete: '/PILEHOME/api/rent/order/delete',
    add: '/PILEHOME/api/rent/order/add',
    // 所有
    listall: '/PILEHOME/api/rent/order/listall',
    export: '/PILEHOME/api/rent/order/export',
    excel: '/PILEHOME/api/rent/order/excel',
    //强制结束
    close: '/PILEHOME/api/rent/order/close',
    //修改结算金额
    settlebal: '/PILEHOME/api/rent/order/settlebal',
    addLvar: '/PILEHOME/api/rentLvar/add',
    editLvar: '/PILEHOME/api/rentLvar/edit',
    findLvar: '/PILEHOME/api/rentLvar/findbyorderid',
    //运维处理结果
    rentcheck: '/PILEHOME/api/rentcheck/findonebyid',
    // 订单反馈
    orderFeedBack: '/PILEHOME/api/orderRentEval/list',
};
//优惠券管理
api.coupon = {
    // 列表
    list: '/PILEHOME/api/coupon/list',
    // 根据id 查询
    findbyid: '/PILEHOME/api/coupon/findbyid',
    // 根据name查询
    findbyname: '/PILEHOME/api/coupon/findbyname',
    // 更新
    update: '/PILEHOME/api/coupon/edit',
    delete: '/PILEHOME/api/coupon/delete',
    add: '/PILEHOME/api/coupon/add',
    export: '/PILEHOME/api/coupon/export',
};

//折扣管理
api.event2 = {
    // 列表
    list: '/PILEHOME/api/onlineEvent/list',
    // 根据id 查询
    findbyid: '/PILEHOME/api/onlineEvent/findonebyid',
    // 根据name查询
    // 更新
    update: '/PILEHOME/api/onlineEvent/edit',
    delete: '/PILEHOME/api/onlineEvent/delete',
    add: '/PILEHOME/api/onlineEvent/add',
};
//客户优惠券
api.custcoupon = {
    // 分配
    add: '/PILEHOME/api/custcoupon/add',
    // 移除
    delete: '/PILEHOME/api/custcoupon/delete',
    // 分页查询
    list: '/PILEHOME/api/custcoupon/list',
    //导出
    export: '/PILEHOME/api/custcoupon/export'
}
//资金管理
api.custwalletlist = {
    // 列表
    list: '/PILEHOME/api/custwalletlist/list',
    // 根据id 查询
    findbyid: '/PILEHOME/api/custwalletlist/findbyid',
    // 所有
    listall: '/PILEHOME/api/custwalletlist/listall',
    //导出
    export: '/PILEHOME/api/custwalletlist/export',
    count: '/PILEHOME/api/custwalletlist/count',
};
// 版本控制
api.appVersion = {
    page: '/PILEHOME/api/appVersion/page',
    delete: '/PILEHOME/api/appVersion/delete/',
    add: '/PILEHOME/api/appVersion/add',
    findonebyid: '/PILEHOME/api/appVersion/findonebyid/',
    edit: '/PILEHOME/api/appVersion/edit',
    listall: '/PILEHOME/api/app/listall',
    export: '/PILEHOME/api/app/export'
};
//充电站信息
api.pile = {
    listall: '/PILEHOME/api/pile/station/listallnoauth',
    findonebyid: '/PILEHOME/api/pile/station/findonebyid',
    importExcel: '/PILEHOME/api/pile/importExcel',
};

// 桩信息列表
api.pileinfo = {
    //list:'/PILEHOME/api/pile/listall?action=1002&size=99999',
    list: '/PILEHOME/api/pile/station/listall',
    //解绑私人充电桩
    del:'/PILEHOME/api/pileuser/webDelete',
    //充电桩查询
    find:`/PILEHOME/api/corp/findByPileInform/`
};

// 车辆历史轨迹——单开页面
api.historicaltrackOnly = {
    //list:'/PILEHOME/api/pile/listall?action=1002&size=99999',
    historicaltrack: '/PILEHOME/api/tmnlinfo/historicaltrack'
};

//充电日志
api.pilerecordhistory = {
    page: '/PILEHOME/api/pilerecordhistory/page',
    export: '/PILEHOME/api/pilerecordhistory/export'
}
// 车辆停留汇总
api.autostopsummary = {
    list: '/PILEHOME/api/tmnlstop/summarypage',
    export: '/PILEHOME/api/tmnlstop/summaryexport'
};

// 车辆停留记录
api.autostoprecord = {
    list: '/PILEHOME/api/tmnlstop/page',
    export: '/PILEHOME/api/tmnlstop/detailexport',
    showplacemap: '/PILEHOME/api/tmnlstop/showplacemap'
};
//广汽充电桩
api.chargingpile = {
    list: '/PILEHOME/api/pile/page',
    type: '/PILEHOME/api/piletype/list',
    edit: '/PILEHOME/api/pile/edit',
    findonebyid: '/PILEHOME/api/pile/info',
    record: '/PILEHOME/api/pileorder/page',
    dealer: '/PILEHOME/api/dealer/list',
    config: '/PILEHOME/api/sysconfig/findbytype',
    typeDetail: '/PILEHOME/api/piletype/info',
    pilestation: '/PILEHOME/api/pilestation/list',
    personRecord: '/PILEHOME/api/pileorder/page',
    statusHistory: '/PILEHOME/api/pilestautshistory/page',
    witricity: '/PILEHOME/api/custpile/witricity/page',
    allowapplication: '/PILEHOME/api/custpile/witricity/allowapplication',
    rejustapplication: '/PILEHOME/api/custpile/witricity/rejustapplication',
    cancelbind: '/PILEHOME/api/custpile/witricity/cancelbind'
};

//广汽充电用户
api.charginguser = {
    list: '/PILEHOME/api/cust/page',
    findonebyid: '/PILEHOME/api/cust/findbyid',
    add: '/PILEHOME/api/cust/add',
    edit: '/PILEHOME/api/cust/edit',
    record: '/PILEHOME/api/pileorder/page',
    detail: '/PILEHOME/api/cust/findbyid',
    account: '/PILEHOME/api/custwalletlist/list',
    close: '/PILEHOME/api/pileorder/close',
    balance: '/PILEHOME/api/cust/modify/balance',
    redeem: '/PILEHOME/api/cust/modify/redeem',
};
//结算策略
api.settle = {
    list: '/PILEHOME/api/strategy/page',
    findonebyid: '/PILEHOME/api/strategy/info',
    edit: '/PILEHOME/api/strategy/edit',
    add: '/PILEHOME/api/strategy/add',
    del: '/PILEHOME/api/strategy/delete',
    //启用
    enable: '/PILEHOME/api/strategy/enable',
    //注销
    disable: '/PILEHOME/api/strategy/disable',
};
// GAG充电网点
api.branch = {
    list: "/PILEHOME/api/pilestation/page",
    delete: "/PILEHOME/api/pilestation/delete",
    add: "/PILEHOME/api/pilestation/add",
    edit: "/PILEHOME/api/pilestation/edit",
    findby: "/PILEHOME/api/pilestation/info",
    branchTariff: "/PILEHOME/api/pilestation/bind/tariff",
    startStation: "/PILEHOME/api/pilestation/start",
    endStation: "/PILEHOME/api/pilestation/finish",
    pileCharge: "/PILEHOME/api/pileCharge/listall",
    pileDelete: "/PILEHOME/api/pilestation/remove/pile",
    pileAdd: "/PILEHOME/api/pilestation/allot/pile",
};
//商城
api.shopping_mall = {
    list: "/PILEHOME/api/good/page ",
    add: "/PILEHOME/api/cart/add",
    car: "/PILEHOME/api/cart/list", //购物车列表
    delete: "/PILEHOME/api/cart/delete",
    settle: "/PILEHOME/api/cart/settle",
    detail: "/PILEHOME/api/order/detail",
    pay: "/PILEHOME/api/order/pay",
    success: "/PILEHOME/api/order/success/"
};
//大屏
api.screen = {
    pileNum: '/PILEHOME/api/dashboard', //统计不同状态下充电桩的数量
    branches: '/PILEHOME/api/dashboard/status/station', //网点
    pile: '/PILEHOME/api/dashboard/status/dealer/station', //大屏充电站点
    charge: '/PILEHOME/api/dashboard/order/station', //(大屏充电收费分析and故障分析统计)
    Ren: '/PILEHOME/api/dashboard/order/{stationNo}' //统计近2天内充电的人数和订单数量
}
api.dashboard = {
    map: "/PILEHOME/api/dashboard/map",
    income: "/PILEHOME/api/dashboard/income",
    statistics: "/PILEHOME/api/dashboard/statistics",
    real: "/PILEHOME/api/dashboard/real",
    pileratio: "/PILEHOME/api/dashboard/pileratio",
}
api.fWUpdateOrder = {
    page: '/PILEHOME/api/fWUpdateOrder/page',
    findbyid: '/PILEHOME/api/fWUpdateOrder/findbyid',
    add: '/PILEHOME/api/fWUpdateOrder/add',
    stop: '/PILEHOME/api/fWUpdateOrder/stop',
    reAdd: '/PILEHOME/api/fWUpdateOrder/reAdd',
}
api.charts = {
    all: '/charts/all',
    city: '/charts/city',
    week: '/charts/week',
}

api.pileorderexcel = {
    export: '/pileorderexcel/export',
    files: '/app/files',
}
// api.charts = {
//     all: '/PILEHOME/api/charts/all',
//     city: '/PILEHOME/api/charts/city',
//     week: '/PILEHOME/api/charts/week',
// }
api.pileSet = {
    /** 查找桩*/
    findOcppPile:'/testPile/ocpp/pile/findOcppPile',
    /** 拟合计划*/
    getCompositeScheduleCmd:'/testPile/ocpp/compositeSchedule/getCompositeScheduleCmd',
    /** 数据传输*/
    dataTransferCmd:'/testPile/ocpp/dataTransfer/dataTransferCmd',
    /** 日志*/
    getLog:'/testPile/ocpp/log/getLog',
    /** 更改可用性*/
    changeAvailability:'/testPile/ocpp/availability/changeAvailability',
    /** 更新固件*/
    updateFirmware:'/testPile/ocpp/firmware/updateFirmware',
    //拓展
    signedUpdateFirmware:'/testPile/ocpp/firmware/signedUpdateFirmware',
    /** 清除缓存*/
    clearCacheCmd: '/testPile/ocpp/clearCache/clearCacheCmd',
    /** 版本*/
        //系统本地
    sendLocalList:'/testPile/ocpp/localList/sendLocalList',
        //获取往期
    getLocalListVersionCmd:'/testPile/ocpp/localList/getLocalListVersionCmd',
    /** 触发消息*/
    triggerMessage:'/testPile/ocpp/message/triggerMessage',
    //拓展
    extendedTriggerMessage:'/testPile/ocpp/message/extendedTriggerMessage',
    /** 证书*/
        //已安装
    certificateSigned:'/testPile/ocpp/certificate/certificateSigned',
        //删除
    deleteCertificate:'/testPile/ocpp/certificate/deleteCertificate',
        //获取
    getInstalledCertificateIds:'/testPile/ocpp/certificate/getInstalledCertificateIds',
        //安装
    installCertificate:'/testPile/ocpp/certificate/installCertificate',
    /** 诊断*/
    getDiagnostics:'/testPile/ocpp/diagnostics/getDiagnostics',
    /** 远程控制*/
        //开始事务
    remoteStartTransaction:'/testPile/ocpp/remotetransaction/remoteStartTransaction',
        //结束事务
    remoteStopTransaction:'/testPile/ocpp/remotetransaction/remoteStopTransaction',
    /** 连接器*/
    unlockConnectorCmd:'/testPile/ocpp/connector/unlockConnectorCmd',
    /** 配置*/
        //获取配置
    getConfiguration:'/testPile/ocpp/configuration/getConfiguration',
        //更改配置
    changeConfiguration:'/testPile/ocpp/configuration/changeConfiguration',
    /** 配置文件*/
        //清除配置文件
    clearChargingProfile:'/testPile/ocpp/chargeingprofile/clearChargingProfile',
        //设置配置
    setChargingProfile:'/testPile/ocpp/chargeingprofile/setChargingProfile',
    /** 重置*/
    resetAll:'/testPile/ocpp/reset/resetAll',
    /** 预约*/
    reserveNow:'/testPile/ocpp/reserve/reserveNow',
    //取消
    cancelReservation:'/testPile/ocpp/reserve/cancelReservation'

}

export default api;
